(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9335],{

/***/ 67099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77058);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _src_components_atoms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52738);
/* harmony import */ var _src_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54176);
/* harmony import */ var _src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9465);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);










var Header = function Header(_ref) {
  var _process$env$NEXT_PUB, _process$env$NEXT_PUB2;

  var setSideMenuShow = _ref.setSideMenuShow;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
    className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .getClass */ .ll)("header", true)),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: "md:block hidden border-b ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .getClass */ .ll)("border-grayBackground")),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        className: "wrapper mx-auto",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: "flex flex-row py-2 items-center justify-between",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "flex flex-row items-center",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
              className: "pr-[36px] relative group",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                prefetch: false,
                href: "/",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
                  className: "text-sm text-white font-bold" // id={
                  //   process.env.NEXT_PUBLIC_APP_NAME != "PrefabWorld" &&
                  //   process.env.NEXT_PUBLIC_APP_NAME != "WorldCasino" &&
                  //   process.env.NEXT_PUBLIC_APP_NAME != "LuxResort Club" &&
                  //   process.env.NEXT_PUBLIC_APP_NAME != "AparthotelClub"
                  //     ? "sub-menu-prelaunch-header"
                  //     : ""
                  // }
                  ,
                  children: "WorldCasino"
                })
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "flex flex-row items-center",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
              className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .getClass */ .ll)("btn-border"), " rounded-full px-3 pb-1 mr-0 h-[30px] flex justify-center items-center w-104px text-center"),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                prefetch: false,
                href: "/".concat((_process$env$NEXT_PUB = "WorldCasino") === null || _process$env$NEXT_PUB === void 0 ? void 0 : (_process$env$NEXT_PUB2 = _process$env$NEXT_PUB.replace(" ", "")) === null || _process$env$NEXT_PUB2 === void 0 ? void 0 : _process$env$NEXT_PUB2.toLowerCase(), "-pro/"),
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
                  className: "text-sm h-[16px] font-semibold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .getClass */ .ll)("text-white", true)),
                  children: t("key_web_apply")
                })
              })
            })
          })]
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: "wrapper-no-padding mx-auto ".concat( true ? "py-1" : 0, " sm:px-9 px-4"),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        className: "flex flex-row items-center justify-between",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "sm:block hidden cursor-pointer w-[150px]",
          onClick: function onClick() {
            return setSideMenuShow(true);
          },
          style: {
            height: 20
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_src_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
            source: "/icons/ic_menu.svg",
            width: 29,
            height: 20,
            layout: "fixed",
            alt: "menu"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "sm:hidden block cursor-pointer w-[30px]",
          onClick: function onClick() {
            return setSideMenuShow(true);
          },
          style: {
            height: 22
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_src_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
            source: "/icons/ic_menu_mobile.svg",
            width: 30,
            height: 22,
            layout: "fixed",
            alt: "menu"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          prefetch: false,
          href: "/",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
            className: "sm:block hidden",
            style: {
              height:  true ? 70 : 0
            },
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_src_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
              source: "/images/logo_worldcasino.png",
              width:  true ? 330 : 0,
              height:  true ? 70 : 0,
              layout: "fixed",
              alt: "".concat("WorldCasino", " logo")
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          prefetch: false,
          href: "/",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
            className: "sm:hidden block",
            style: {
              height:  true ? 50 : 0
            },
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_src_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
              source: "/images/logo_worldcasino.png",
              width:  true ? 240 : 0,
              height:  true ? 50 : 0,
              layout: "fixed",
              alt: "".concat("WorldCasino", " logo")
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "sm:hidden block w-[30px]",
          children: "\xA0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "sm:block hidden w-[150px]",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: "/guides",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
              className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .getClass */ .ll)("btn-gradient"), " flex justify-center items-center w-150px h-40px rounded-full uppercase cursor-pointer"),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                className: "text-white text-base font-bold",
                children: "Guides"
              })
            })
          })
        })]
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Header);

/***/ }),

/***/ 92063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _src_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54176);
/* harmony import */ var _src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9465);
/* harmony import */ var react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28908);
/* harmony import */ var react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);









var SideMenu = function SideMenu(_ref) {
  var _process$env$NEXT_PUB, _process$env$NEXT_PUB2;

  var sideMenuShow = _ref.sideMenuShow,
      setSideMenuShow = _ref.setSideMenuShow,
      sideMenuHeaderShow = _ref.sideMenuHeaderShow,
      setSideMenuHeaderShow = _ref.setSideMenuHeaderShow;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
      className: "fixed top-0 left-0 ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("bg-black7", true), " h-screen overflow-y-auto w-305px ").concat(sideMenuShow ? "translate-x-0 opacity-100" : "-translate-x-full opacity-0", " transition-all duration-300 h-full z-[999]"),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
        className: "pt-10 pl-8",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
          className: "cursor-pointer inline-block",
          onClick: function onClick() {
            return setSideMenuShow(false);
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("svg", {
            width: "17",
            height: "17",
            viewBox: "0 0 17 17",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M0.646446 1.35355C0.451185 1.15829 0.451185 0.841709 0.646446 0.646447C0.841709 0.451184 1.15829 0.451184 1.35355 0.646447L8.5 7.79289L15.6464 0.646447C15.8417 0.451184 16.1583 0.451184 16.3536 0.646447C16.5488 0.841709 16.5488 1.15829 16.3536 1.35355L9.20711 8.5L16.3536 15.6464C16.5488 15.8417 16.5488 16.1583 16.3536 16.3536C16.1583 16.5488 15.8417 16.5488 15.6464 16.3536L8.5 9.20711L1.35355 16.3536C1.15829 16.5488 0.841709 16.5488 0.646447 16.3536C0.451185 16.1583 0.451185 15.8417 0.646447 15.6464L7.79289 8.5L0.646446 1.35355Z",
              fill: (0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("svg-white")
            })
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
        // id={
        //   process.env.NEXT_PUBLIC_APP_NAME != "PrefabWorld" &&
        //   process.env.NEXT_PUBLIC_APP_NAME != "WorldCasino" &&
        //   process.env.NEXT_PUBLIC_APP_NAME != "LuxResort Club" &&
        //   process.env.NEXT_PUBLIC_APP_NAME != "AparthotelClub"
        //     ? "sub-menu-prelaunch"
        //     : ""
        // }
        className: "border-b ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("border-white2"), " pt-7 pb-4 pl-8"),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
          className: "text-base ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("text-white", true), " font-bold cursor-pointer") // onClick={() => setSideMenuHeaderShow(!sideMenuHeaderShow)}
          ,
          children: "WorldCasino"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
        className: "pl-8 pt-1 py-3 border-b ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("border-white2")),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          prefetch: false,
          href: "/",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
            className: "block text-base ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("text-white", true), " font-regular uppercase py-3"),
            children: "Home"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          prefetch: false,
          href: "/guides",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
            className: "block text-base ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("text-white", true), " font-regular uppercase py-3"),
            children: "Guides"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          prefetch: false,
          href: "/".concat((_process$env$NEXT_PUB = "WorldCasino") === null || _process$env$NEXT_PUB === void 0 ? void 0 : (_process$env$NEXT_PUB2 = _process$env$NEXT_PUB.replace(" ", "")) === null || _process$env$NEXT_PUB2 === void 0 ? void 0 : _process$env$NEXT_PUB2.toLowerCase(), "-pro/"),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
            className: "block text-base ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("text-white", true), " font-regular uppercase py-3"),
            children: "Apply"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          prefetch: false,
          href: "/about",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
            className: "block text-base ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("text-white", true), " font-regular uppercase py-3"),
            children: "About"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          prefetch: false,
          href: "/contact",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
            className: "block text-base ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("text-white", true), " font-regular uppercase py-3"),
            children: "Contact"
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
        className: "pl-8 pt-1 py-3",
        children: [ true && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
          href: "/gambling-help",
          className: "block text-base ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("text-gray2-dark", true), " font-regular py-3"),
          children: "Gambling Help"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
          href: "/cookie-policy",
          className: "block text-base ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("text-gray2-dark", true), " font-regular py-3"),
          children: "Cookies"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          prefetch: false,
          href: "/legal",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
            className: "block text-base ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("text-gray2-dark", true), " font-regular py-3"),
            children: "Legal"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          prefetch: false,
          href: "/sitemap.xml",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
            className: "block text-base ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("text-gray2-dark", true), " font-regular py-3"),
            children: "Sitemap"
          })
        })]
      })]
    }), sideMenuShow && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_6___default()), {
      style: {
        backgroundColor: "rgba(89, 89, 89, 0.45)",
        width: "100%",
        height: "100%",
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: 500
      },
      onPress: function onPress() {
        return setSideMenuShow(false);
      }
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SideMenu);

/***/ }),

/***/ 17431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(77058);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2962);
/* harmony import */ var _components_web_Header__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67099);
/* harmony import */ var _components_web_Footer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52460);
/* harmony import */ var _components_web_SideMenu__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92063);
/* harmony import */ var _src_api__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87733);
/* harmony import */ var _src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9465);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);












var Contact = function Contact() {
  var _process$env$NEXT_PUB, _process$env$NEXT_PUB2;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_9__/* .useTranslation */ .$)(),
      t = _useTranslation.t;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      sideMenuShow = _useState[0],
      setSideMenuShow = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      sideMenuHeaderShow = _useState2[0],
      setSideMenuHeaderShow = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""),
      email = _useState3[0],
      setEmail = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      statusNewsletter = _useState4[0],
      setStatusNewsletter = _useState4[1];

  var actionSubscribe = function actionSubscribe() {
    _src_api__WEBPACK_IMPORTED_MODULE_6__/* .ProfileService.subscribeNewsletter */ .H3.subscribeNewsletter({
      email: email
    }).then(function (res) {
      setStatusNewsletter(res.data.message);
      setEmail("");
    })["catch"](function (err) {
      var _err$data;

      setStatusNewsletter(err === null || err === void 0 ? void 0 : (_err$data = err.data) === null || _err$data === void 0 ? void 0 : _err$data.message);
      setEmail("");
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_2__/* .NextSeo */ .PB, {
      title: "Contact - ".concat("WorldCasino"),
      canonical: "https://".concat("www.worldcasino.org", "/contact"),
      additionalMetaTags: {
        name: "keywords",
        content: "contact, festival, event, artist, music, live music, concert, ticket"
      },
      openGraph: {
        type: "website",
        locale: "en_EN",
        url: "https://".concat("www.worldcasino.org", "/contact"),
        title: "Contact - ".concat("WorldCasino"),
        images: [{
          url: "https://".concat("www.worldcasino.org").concat("/images/og-worldcasino.png"),
          width: 1200,
          height: 630,
          alt: "".concat("WorldCasino").concat(""),
          type: "image/png"
        }],
        siteName: "".concat("WorldCasino").concat("")
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_components_web_Header__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      setSideMenuShow: setSideMenuShow
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_components_web_SideMenu__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      sideMenuShow: sideMenuShow,
      setSideMenuShow: setSideMenuShow,
      sideMenuHeaderShow: sideMenuHeaderShow,
      setSideMenuHeaderShow: setSideMenuHeaderShow
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
      className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_7__/* .getClass */ .ll)("background", true)),
      id: "contact",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
        className: "wrapper mx-auto relative px-10 min-h-screen py-60 flex justify-center items-center",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
          className: "max-w-1160px flex-1 mx-auto",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
            className: "flex flex-col items-center",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("h1", {
              className: "sm:text-3xl text-lg font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_7__/* .getClass */ .ll)("text-white", true), " text-center sm:mb-14 mb-6"),
              children: t("key_web_home_contact_title")
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
              className: "grid md:grid-cols-3 grid-cols-1 sm:gap-10 gap-5",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
                className: "px-0",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                  className: "sm:text-xl text-lg font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_7__/* .getClass */ .ll)("text-white", true), " text-center mb-2"),
                  children: t("key_web_home_contact_item_1_title")
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                  className: "sm:text-lg text-sm font-regular text-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_7__/* .getClass */ .ll)("text-white80", true), " mb-2"),
                  children: t("key_web_home_contact_item_1_subtitle")
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                  className: "sm:text-lg text-sm font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_7__/* .getClass */ .ll)("text-white", true), " text-center"),
                  children: "info@supervybe.com"
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
                className: "px-0",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                  className: "sm:text-xl text-lg font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_7__/* .getClass */ .ll)("text-white", true), " text-center mb-2"),
                  children: t("key_web_home_contact_item_2_title")
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                  className: "sm:text-lg text-sm font-regular text-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_7__/* .getClass */ .ll)("text-white80", true), " mb-2"),
                  children: t("key_web_home_contact_item_2_subtitle")
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                  className: "sm:text-lg text-sm font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_7__/* .getClass */ .ll)("text-white", true), " text-center"),
                  children: "press@supervybe.com"
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
                className: "px-0",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                  className: "sm:text-xl text-lg font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_7__/* .getClass */ .ll)("text-white", true), " text-center mb-2"),
                  children: t("key_web_home_contact_item_3_title")
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                  className: "sm:text-lg text-sm font-regular text-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_7__/* .getClass */ .ll)("text-white80", true), " mb-2"),
                  children: t("key_web_home_contact_item_3_subtitle")
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                  className: "sm:text-lg text-sm font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_7__/* .getClass */ .ll)("text-white", true), " text-center"),
                  children: "business@supervybe.com"
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
                className: "px-0",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                  className: "sm:text-xl text-lg font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_7__/* .getClass */ .ll)("text-white", true), " text-center mb-2"),
                  children: t("key_web_home_contact_item_4_title")
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                  className: "sm:text-lg text-sm font-regular text-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_7__/* .getClass */ .ll)("text-white80", true), " mb-2"),
                  children: t("key_web_home_contact_item_4_subtitle")
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                  className: "sm:text-lg text-sm font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_7__/* .getClass */ .ll)("text-white", true), " text-center"),
                  children: "ad@supervybe.com"
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
                className: "px-0",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                  className: "sm:text-xl text-lg font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_7__/* .getClass */ .ll)("text-white", true), " text-center mb-2"),
                  children: t("key_web_home_contact_item_5_title")
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                  className: "sm:text-lg text-sm font-regular text-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_7__/* .getClass */ .ll)("text-white80", true), " mb-2"),
                  children: t("key_web_home_contact_item_5_subtitle")
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                  className: "sm:text-lg text-sm font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_7__/* .getClass */ .ll)("text-white", true), " text-center"),
                  children: "report@supervybe.com"
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
                className: "px-0",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                  className: "sm:text-xl text-lg font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_7__/* .getClass */ .ll)("text-white", true), " text-center mb-2"),
                  children: t("key_web_home_contact_item_6_title")
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                  className: "sm:text-lg text-sm font-regular text-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_7__/* .getClass */ .ll)("text-white80", true), " mb-2"),
                  children: t("key_web_home_contact_item_6_subtitle")
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                  className: "sm:text-lg text-sm font-regular text-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_7__/* .getClass */ .ll)("text-white80", true), " mb-2"),
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    prefetch: false,
                    href: "/".concat((_process$env$NEXT_PUB = "WorldCasino") === null || _process$env$NEXT_PUB === void 0 ? void 0 : (_process$env$NEXT_PUB2 = _process$env$NEXT_PUB.replace(" ", "")) === null || _process$env$NEXT_PUB2 === void 0 ? void 0 : _process$env$NEXT_PUB2.toLowerCase(), "-pro/"),
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("a", {
                      title: t("key_web_here"),
                      className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_7__/* .getClass */ .ll)("text-white", true), " font-bold underline"),
                      children: t("key_web_here")
                    })
                  })
                })]
              })]
            })]
          })
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_components_web_Footer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Contact);

/***/ }),

/***/ 87733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jm": function() { return /* reexport */ ArtistService; },
  "W1": function() { return /* reexport */ FestivalService; },
  "YD": function() { return /* reexport */ HomeService; },
  "aU": function() { return /* reexport */ LocationService; },
  "H3": function() { return /* reexport */ ProfileService; },
  "co": function() { return /* reexport */ TagService; },
  "wP": function() { return /* reexport */ TicketService; },
  "P8": function() { return /* reexport */ VenueService; },
  "k_": function() { return /* binding */ apiCall; },
  "O": function() { return /* binding */ objToQueryString; }
});

// UNUSED EXPORTS: apiCallFormData, getAccessToken, isCloseToBottom, mockApiCall, refreshAccessToken

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./src/config/index.js + 8 modules
var config = __webpack_require__(54176);
;// CONCATENATED MODULE: ./src/api/FestivalService/index.js



var getSpotifyFestivals = function getSpotifyFestivals() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var parameters = {
    pageIndex: 0,
    pageSize: 100
  };

  for (var key in params) {
    if (params[key]) {
      parameters[key] = params[key];
    }
  }

  var request = {
    url: "".concat(config/* Api.baseURL */.V0.baseURL, "/spotify-related-festivals"),
    method: "post",
    body: JSON.stringify(parameters)
  };
  return apiCall(request);
};

var getFestivals = function getFestivals() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var parameters = {
    pageIndex: 0,
    pageSize: 20
  };

  for (var key in params) {
    if (params[key]) {
      parameters[key] = params[key];
    }
  }

  var request = {
    url: "".concat(config/* Api.baseURL */.V0.baseURL, "/festivals"),
    method: "post",
    body: JSON.stringify(parameters)
  };
  return apiCall(request);
};

var getFestivalsWeb = function getFestivalsWeb() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var parameters = {
    pageIndex: 0,
    pageSize: 20
  };

  for (var key in params) {
    if (params[key]) {
      parameters[key] = params[key];
    }
  }

  var request = {
    url: "".concat(config/* Api.baseURL */.V0.baseURL, "/web/festivals"),
    method: "post",
    body: JSON.stringify(parameters)
  };
  return apiCall(request);
};

var getFestival = function getFestival(id) {
  var request = {
    url: "".concat(config/* Api.baseURL */.V0.baseURL, "/festival/").concat(id),
    method: "get"
  };
  return apiCall(request);
};

var getFestivalByProfileId = function getFestivalByProfileId(profileId) {
  var request = {
    url: "".concat(config/* Api.baseURL */.V0.baseURL, "/festival/profile/").concat(profileId),
    method: "get"
  };
  return apiCall(request);
};

var getAmenitiesByEventId = function getAmenitiesByEventId(eventId) {
  var parameters = {
    eventId: eventId
  };
  var request = {
    url: "".concat(config/* Api.baseURL */.V0.baseURL, "/amenities?") + objToQueryString(parameters),
    method: "get"
  };
  return apiCall(request);
};

var getInsightByEventId = function getInsightByEventId(eventId) {
  var parameters = {
    eventId: eventId
  };
  var request = {
    url: "".concat(config/* Api.baseURL */.V0.baseURL, "/insight?") + objToQueryString(parameters),
    method: "get"
  };
  return apiCall(request);
};

/* harmony default export */ var FestivalService = ({
  getFestivals: getFestivals,
  getFestivalsWeb: getFestivalsWeb,
  getFestival: getFestival,
  getFestivalByProfileId: getFestivalByProfileId,
  getAmenitiesByEventId: getAmenitiesByEventId,
  getInsightByEventId: getInsightByEventId,
  getSpotifyFestivals: getSpotifyFestivals
});
;// CONCATENATED MODULE: ./src/api/ArtistService/index.js



var getArtistCountries = function getArtistCountries(profileId) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parameters = {
    pageIndex: 0,
    pageSize: 20
  };

  for (var key in params) {
    if (params[key]) {
      parameters[key] = params[key];
    }
  }

  var request = {
    url: "".concat(config/* Api.baseURL */.V0.baseURL, "/artist/profile/").concat(profileId, "/countries?") + objToQueryString(parameters),
    method: "get"
  };
  return apiCall(request);
};

var getArtists = function getArtists() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var parameters = {
    pageIndex: 0,
    pageSize: 20
  };

  for (var key in params) {
    if (params[key]) {
      parameters[key] = params[key];
    }
  }

  var request = {
    url: "".concat(config/* Api.baseURL */.V0.baseURL, "/artists"),
    method: "post",
    body: JSON.stringify(parameters)
  };
  return apiCall(request);
};

var getWebArtists = function getWebArtists() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var parameters = {
    pageIndex: 0,
    pageSize: 20
  };

  for (var key in params) {
    if (params[key]) {
      parameters[key] = params[key];
    }
  }

  var request = {
    url: "".concat(config/* Api.baseURL */.V0.baseURL, "/web/artists"),
    method: "post",
    body: JSON.stringify(parameters)
  };
  return apiCall(request);
};

var syncArtistFollowing = function syncArtistFollowing(accessToken) {
  var parameters = {
    accessToken: accessToken
  };
  var request = {
    url: "".concat(config/* Api.baseURL */.V0.baseURL, "/me/sync/spotify_artist_followings"),
    method: "post",
    body: JSON.stringify(parameters)
  };
  return apiCall(request);
};

var getLineupArtists = function getLineupArtists(eventId) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parameters = {
    pageIndex: 0,
    pageSize: 20
  };

  for (var key in params) {
    if (params[key]) {
      parameters[key] = params[key];
    }
  }

  var request = {
    url: "".concat(config/* Api.baseURL */.V0.baseURL, "/event/").concat(eventId, "/lineup?") + objToQueryString(parameters),
    method: "get"
  };
  return apiCall(request);
};

var getArtist = function getArtist(id) {
  var request = {
    url: "".concat(config/* Api.baseURL */.V0.baseURL, "/artist/").concat(id),
    method: "get"
  };
  return apiCall(request);
};

var getArtistByProfileId = function getArtistByProfileId(id) {
  var request = {
    url: "".concat(config/* Api.baseURL */.V0.baseURL, "/artist/profile/").concat(id),
    method: "get"
  };
  return apiCall(request);
};

/* harmony default export */ var ArtistService = ({
  getArtists: getArtists,
  getWebArtists: getWebArtists,
  getArtist: getArtist,
  getLineupArtists: getLineupArtists,
  getArtistByProfileId: getArtistByProfileId,
  getArtistCountries: getArtistCountries,
  syncArtistFollowing: syncArtistFollowing
});
;// CONCATENATED MODULE: ./src/api/HomeService/index.js



var getHomeCategories = function getHomeCategories() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var parameters = {};

  for (var key in params) {
    if (params[key]) {
      parameters[key] = params[key];
    }
  }

  var request = {
    url: "".concat(config/* Api.baseURL */.V0.baseURL, "/home"),
    method: 'post',
    body: JSON.stringify(parameters)
  };
  return apiCall(request);
};

/* harmony default export */ var HomeService = ({
  getHomeCategories: getHomeCategories
});
;// CONCATENATED MODULE: ./src/api/TicketService/index.js



var getTickets = function getTickets() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var parameters = {};

  for (var key in params) {
    if (params[key]) {
      parameters[key] = params[key];
    }
  }

  var request = {
    url: "".concat(config/* Api.baseURL */.V0.baseURL, "/tickets?") + objToQueryString(parameters),
    method: 'get'
  };
  return apiCall(request);
};

var createTicket = function createTicket() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var request = {
    url: "".concat(config/* Api.baseURL */.V0.baseURL, "/ticket"),
    method: 'put',
    body: JSON.stringify(params)
  };
  return apiCall(request);
};

var actionClick = function actionClick(ticketID) {
  var request = {
    url: "".concat(config/* Api.baseURL */.V0.baseURL, "/festival/ticket-click/").concat(ticketID),
    method: 'post'
  };
  return apiCall(request);
};

/* harmony default export */ var TicketService = ({
  getTickets: getTickets,
  createTicket: createTicket,
  actionClick: actionClick
});
;// CONCATENATED MODULE: ./src/api/ProfileService/index.js



var getProfileFind = function getProfileFind() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var parameters = {
    pageIndex: 0,
    pageSize: 20
  };

  for (var key in params) {
    if (params[key]) {
      parameters[key] = params[key];
    }
  }

  var request = {
    url: "".concat(config/* Api.baseURL */.V0.baseURL, "/profiles/find"),
    method: 'post',
    body: JSON.stringify(parameters)
  };
  return apiCall(request);
};

var getProfileStatistics = function getProfileStatistics() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var parameters = {};

  for (var key in params) {
    if (params[key]) {
      parameters[key] = params[key];
    }
  }

  var request = {
    url: "".concat(config/* Api.baseURL */.V0.baseURL, "/profiles/statistics"),
    method: 'post',
    body: JSON.stringify(parameters)
  };
  return apiCall(request);
};

var getProfileByUserId = function getProfileByUserId(userId) {
  var request = {
    url: "".concat(config/* Api.baseURL */.V0.baseURL, "/profile?userId=").concat(userId),
    method: 'get'
  };
  return apiCall(request);
};

var getProfileByProfileId = function getProfileByProfileId(profileId) {
  var request = {
    url: "".concat(config/* Api.baseURL */.V0.baseURL, "/profile/").concat(profileId),
    method: 'get'
  };
  return apiCall(request);
};

var deleteAccount = function deleteAccount() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var parameters = {
    email: params.email,
    password: params.password,
    notes: params.notes
  };
  var request = {
    url: "".concat(config/* Api.baseURL */.V0.baseURL, "/delete-account"),
    method: 'put',
    body: JSON.stringify(parameters)
  };
  return apiCall(request);
};

var updatePlayerIDOneSignal = function updatePlayerIDOneSignal() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var parameters = {
    playerID_oneSignal: params.playerID_oneSignal
  };
  var request = {
    url: "".concat(config/* Api.baseURL */.V0.baseURL, "/playerid-onesignal"),
    method: 'put',
    body: JSON.stringify(parameters)
  };
  return apiCall(request);
};

var validateUsername = function validateUsername() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var parameters = {
    username: params.username
  };
  var request = {
    url: "".concat(config/* Api.baseURL */.V0.baseURL, "/validateUsername"),
    method: 'post',
    body: JSON.stringify(parameters)
  };
  return apiCall(request);
};

var subscribeNewsletter = function subscribeNewsletter() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var parameters = {
    email: params.email
  };
  var request = {
    url: "".concat(config/* Api.baseURL */.V0.baseURL, "/subscribe-newsletter"),
    method: 'post',
    body: JSON.stringify(parameters)
  };
  return apiCall(request);
};

/* harmony default export */ var ProfileService = ({
  getProfileFind: getProfileFind,
  getProfileStatistics: getProfileStatistics,
  getProfileByUserId: getProfileByUserId,
  getProfileByProfileId: getProfileByProfileId,
  deleteAccount: deleteAccount,
  updatePlayerIDOneSignal: updatePlayerIDOneSignal,
  validateUsername: validateUsername,
  subscribeNewsletter: subscribeNewsletter
});
;// CONCATENATED MODULE: ./src/api/LocationService/index.js



var getLocations = function getLocations() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var parameters = {
    pageIndex: 0,
    pageSize: 5
  };

  for (var key in params) {
    if (params[key]) {
      parameters[key] = params[key];
    }
  }

  var request = {
    url: "".concat(config/* Api.baseURL */.V0.baseURL, "/locations?") + objToQueryString(parameters),
    method: "get"
  };
  return apiCall(request);
};

var getProgmaticLocations = function getProgmaticLocations() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var parameters = {};

  for (var key in params) {
    if (params[key]) {
      parameters[key] = params[key];
    }
  }

  var request = {
    url: "".concat(config/* Api.baseURL */.V0.baseURL, "/progmatic-locations?") + objToQueryString(parameters),
    method: "get"
  };
  return apiCall(request);
};

/* harmony default export */ var LocationService = ({
  getLocations: getLocations,
  getProgmaticLocations: getProgmaticLocations
});
;// CONCATENATED MODULE: ./src/api/TagService/index.js



var getProfileTags = function getProfileTags() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var request = {
    url: "".concat(config/* Api.baseURL */.V0.baseURL, "/profile_tags?") + objToQueryString(params),
    method: 'get'
  };
  return apiCall(request);
};

var updateProfileTags = function updateProfileTags() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var request = {
    url: "".concat(config/* Api.baseURL */.V0.baseURL, "/profile_tags"),
    method: 'post',
    body: JSON.stringify(params)
  };
  return apiCall(request);
};

/* harmony default export */ var TagService = ({
  getProfileTags: getProfileTags,
  updateProfileTags: updateProfileTags
});
;// CONCATENATED MODULE: ./src/api/VenueService/index.js



var getVenues = function getVenues() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var parameters = {
    pageIndex: 0,
    pageSize: 20
  };

  for (var key in params) {
    if (params[key]) {
      parameters[key] = params[key];
    }
  }

  var request = {
    url: "".concat(config/* Api.baseURL */.V0.baseURL, "/find-venues"),
    method: "post",
    body: JSON.stringify(parameters)
  };
  return apiCall(request);
};

var getVenue = function getVenue(id) {
  var request = {
    url: "".concat(config/* Api.baseURL */.V0.baseURL, "/venue/").concat(id),
    method: "get"
  };
  return apiCall(request);
};

/* harmony default export */ var VenueService = ({
  getVenues: getVenues,
  getVenue: getVenue
});
// EXTERNAL MODULE: ./src/helpers/jwtHelper.js
var jwtHelper = __webpack_require__(88379);
// EXTERNAL MODULE: ./src/helpers/storageHelper.js
var storageHelper = __webpack_require__(87148);
;// CONCATENATED MODULE: ./src/api/index.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











 // import { _persistAuth } from "../modules/auth/redux/actions/AuthActions";

var mockApiCall = function mockApiCall(request, response) {
  return new Promise(function (resolve, reject) {
    resolve(response);
  });
};
var refreshAccessToken = function refreshAccessToken(refreshToken) {
  var parameters = {
    refreshToken: refreshToken
  };
  var request = {
    url: "".concat(config/* Api.baseURL */.V0.baseURL, "/token"),
    method: "post",
    body: JSON.stringify(parameters)
  };
  var defaults = {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: ""
    }
  };
  return new Promise(function (resolve, reject) {
    fetch(request.url, _objectSpread(_objectSpread({}, defaults), request)).then(function (res) {
      if (res.ok) {
        return res.json().then(function (data) {
          resolve(data);
        });
      } else {
        return res.json().then(function (data) {
          reject(data);
        });
      }
    })["catch"](function (error) {
      reject({});
    });
  });
};
var getAccessToken = function getAccessToken() {
  var isForceToRefreshToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return new Promise(function (resolve) {
    (0,storageHelper/* getLocalAuth */._Q)().then(function (auth) {
      var accessToken = auth.accessToken,
          refreshToken = auth.refreshToken;

      if ((0,jwtHelper/* verifyToken */.W)(accessToken) && !isForceToRefreshToken) {
        resolve(accessToken);
      } else {
        if (refreshToken) {
          refreshAccessToken(refreshToken).then(function (response) {
            auth.accessToken = response.data; // _persistAuth(auth);

            resolve(response.data);
          })["catch"](function (err) {
            resolve();
          });
        } else {
          resolve();
        }
      }
    })["catch"](function () {
      resolve();
    });
  });
};
var apiCallFormData = function apiCallFormData(url, formData) {
  return new Promise(function (resolve, reject) {
    getAccessToken().then(function (accessToken) {
      var request = {
        url: url,
        method: "post",
        body: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: accessToken ? "Bearer ".concat(accessToken) : ""
        }
      };
      return fetch(request.url, request).then(function (res) {
        if (res.status === 204) {
          resolve({});
        } else if (res.ok) {
          return res.json().then(function (data) {
            resolve({
              data: data
            });
          });
        } else if (res.status === 401) {
          removeAuth();
          reject({});
        } else {
          return res.json().then(function (data) {
            reject({
              data: data
            });
          });
        }
      })["catch"](function (error) {
        console.error("error", error);
        reject({});
      });
    })["catch"](function (err) {
      console.error("error", err);
      reject({});
    });
  });
};
var apiCall = function apiCall(request) {
  return new Promise(function (resolve, reject) {
    getAccessToken().then(function (accessToken) {
      var defaults = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: accessToken ? "Bearer ".concat(accessToken) : ""
        }
      };
      return fetch(request.url, _objectSpread(_objectSpread({}, defaults), request)).then(function (res) {
        if (res.status === 204) {
          resolve({});
        } else if (res.ok) {
          return res.json().then(function (data) {
            resolve({
              data: data
            });
          });
        } else if (res.status === 401) {
          (0,storageHelper/* removeAuth */.M7)();
          reject({});
        } else {
          return res.json().then(function (data) {
            console.error("error", data);
            reject({
              data: data
            });
          });
        }
      })["catch"](function (error) {
        console.error("error", error);
        reject({});
      });
    })["catch"](function (err) {
      console.error("error", err);
      reject({});
    });
  });
};
function objToQueryString(obj) {
  var keyValuePairs = [];

  for (var key in obj) {
    keyValuePairs.push(encodeURIComponent(key) + "=" + encodeURIComponent(obj[key]));
  }

  return keyValuePairs.join("&");
}
function isCloseToBottom(_ref) {
  var layoutMeasurement = _ref.layoutMeasurement,
      contentOffset = _ref.contentOffset,
      contentSize = _ref.contentSize;
  var paddingToBottom = 20;
  return layoutMeasurement.height + contentOffset.y >= contentSize.height - paddingToBottom;
}


/***/ }),

/***/ 48105:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(17431);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,2427,2738,2460,9774,2888,179], function() { return __webpack_exec__(48105); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);